import * as types from './actionTypes';
import {api} from '../utility';
import store from 'store';

export function setCurrentPostId(postId){
  return {type: types.SET_CURRENT_POST_ID, postId};
}

export function setCurrentPage(permalink){
  return {type: types.SET_CURRENT_PAGE, permalink};
}

export function setCurrentPageLoading(isLoading) {
  return { type: types.SET_CURRENT_PAGE_LOADING, isLoading};
}

export function setShouldTryAutoloading(shouldTryAutoloading) {
  return { type: types.SET_SHOULD_TRY_AUTOLOADING, shouldTryAutoloading }
}

export function fetchCurrentPagePermalink(){
  return function (dispatch, getState) {
    var url = new URL(window.location.href);
    var postId = url.searchParams.get("post");
    dispatch(setCurrentPostId(postId));
    return jQuery.ajax({
            url: ajaxurl,
            type: 'POST',
            data: {
              action: 'get_permalink_for_post_id',
              post_id: postId
            }
          }).then(function(response) {
            console.log('data is ', response);
            if(response.error){
              throw response.error.message;
            }
            return dispatch(setCurrentPage(response.permalink));
          })
  };
}